import { TextField, Box } from '@mui/material';

function DateRangeFilterInput({ item, applyValue }) {
  const handleStartChange = (event) => {
    applyValue({ ...item, value: { ...item.value, start: event.target.value } });
  };

  const handleEndChange = (event) => {
    applyValue({ ...item, value: { ...item.value, end: event.target.value } });
  };

  return (
    <Box sx={{ display: 'flex', gap: 1,mt:2,ml:1 }}>
      <TextField
        type="date"
        value={item.value?.start || ''}
        onChange={handleStartChange}
        variant="standard"
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        type="date"
        value={item.value?.end || ''}
        onChange={handleEndChange}
        variant="standard"
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
}

export default DateRangeFilterInput;
